<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <label>Select date</label>
                  <md-datepicker v-model="form.reportDate" md-immediately>
                  </md-datepicker>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-30">
                  <md-checkbox v-model="form.isPartial"
                    >Partial/Non Inpsection?</md-checkbox
                  >
                </div>
                <div
                  v-show="form.isPartial"
                  class="md-layout-item md-small-size-100 md-size-70"
                >
                  <md-field>
                    <label>Note</label>
                    <md-input v-model="form.partialNote" type="text"></md-input>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
            >
              <md-icon class="material-icons">check</md-icon>Submit
            </md-button>
            <md-button class="md-danger md-sm" @click="onCancel">
              <md-icon class="material-icons">close</md-icon>Cancel
            </md-button>
          </md-card-actions>
        </md-card>

        <md-card v-show="form.isPartial" class="md-accent" md-with-hover>
          <md-ripple>
            <md-card-content>
              <strong>Note:</strong>
              All items on the exisiting report will be carried over to the new
              partial report in their current state. They will not be treated as
              repeat items.
            </md-card-content>
          </md-ripple>
        </md-card>

        <md-card
          v-if="statInspItemEligibleForClosure.length > 0 && !form.isPartial"
        >
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                Items eligible for closure
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="statInspItemEligibleForClosure"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell>
                  <Badge v-if="isClosed(item.id)" :type="status(3).colour">{{
                    status(3).name
                  }}</Badge>
                  <Badge
                    v-if="!isClosed(item.id)"
                    :type="status(item.statInspItemStatusId).colour"
                    >{{ status(item.statInspItemStatusId).name }}</Badge
                  >
                </md-table-cell>
                <md-table-cell md-label="Type">
                  {{ type(item.statInspItemTypeId) }}
                </md-table-cell>
                <md-table-cell md-label="Description">
                  {{ item.description }}
                </md-table-cell>
                <md-table-cell class="text-right">
                  <md-button
                    v-if="!isClosed(item.id)"
                    class="md-just-icon md-success"
                    @click="setItemToClosed(item.id)"
                  >
                    <md-tooltip>Set to closed</md-tooltip>
                    <md-icon>check</md-icon>
                  </md-button>
                  <md-button
                    v-if="isClosed(item.id)"
                    :class="
                      'md-just-icon md-' +
                        status(item.statInspItemStatusId).colour
                    "
                    @click="resetItemStatus(item.id)"
                  >
                    <md-tooltip>Undo</md-tooltip>
                    <md-icon>undo</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>

        <md-card
          v-if="statInspItemNotEligibleForClosure.length > 0 && !form.isPartial"
        >
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                Repeat Items for new report
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <p>
              The items listed below cannot be closed as they are in a state of
              Overdue, Quote, Queried or Frustrated. This means they should
              appear on the new report and will be carried over as a repeat
              item. Their status will remain the same.
            </p>
            <p>
              <strong
                >If any Overdue, Quote or Queried items below do not appear on
                the new report, please contact the relevant party to find out
                why this is the case.</strong
              >
            </p>
            <md-table
              v-model="statInspItemNotEligibleForClosure"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell>
                  <Badge :type="status(item.statInspItemStatusId).colour">{{
                    status(item.statInspItemStatusId).name
                  }}</Badge>
                </md-table-cell>
                <md-table-cell md-label="Type">
                  {{ type(item.statInspItemTypeId) }}
                </md-table-cell>
                <md-table-cell md-label="Description">
                  {{ item.description }}
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                >No Statutory Inspection Items to be carried
                over</md-table-empty-state
              >
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import { mapGetters } from "vuex";
import { Badge } from "@/components";

export default {
  name: "next-stat-insp",
  components: {
    Badge
  },
  data() {
    return {
      hasSubmit: false,
      form: {
        reportDate: new Date(),
        isPartial: false,
        partialNote: "",
        statInspId: "",
        statInspItemIdsToClose: []
      }
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInspItemEligibleForClosure:
        "stat-insp/statInspItemEligibleForClosure",
      statInspItemNotEligibleForClosure:
        "stat-insp/statInspItemNotEligibleForClosure",
      status: "stat-insp/statInspItemStatus",
      type: "stat-insp/statInspItemType"
    })
  },
  methods: {
    prepareTheFormForSubmission() {
      this.form.reportDate = moment(this.form.reportDate).format("YYYY-MM-DD");
      this.form.statInspId = this.$route.params.statInspId;
      if (this.form.isPartial) {
        this.form.statInspItemIdsToClose = [];
      }
    },
    setItemToClosed(id) {
      this.form.statInspItemIdsToClose.push(id);
    },
    isClosed(id) {
      return this.form.statInspItemIdsToClose.includes(id);
    },
    resetItemStatus(id) {
      this.form.statInspItemIdsToClose.splice(
        this.form.statInspItemIdsToClose.indexOf(id),
        1
      );
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.push({
        path: `/stat-insp/${this.$route.params.statInspId}`
      });
    },
    onSubmit() {
      Swal.fire({
        text: `Are you sure you want to create the next report?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.hasSubmit = true;
          this.prepareTheFormForSubmission();
          this.$store
            .dispatch("stat-insp/createNextStatInspReport", this.form)
            .then(data => {
              this.$router.push({ path: `/stat-insp/${data.id}` });
            })
            .catch(error => {
              this.hasSubmit = false;
              let errors = [];
              if (error.response.data[0] === undefined) {
                // handle validation error
                let validationErrorDictionary = error.response.data.errors;
                for (var fieldName in validationErrorDictionary) {
                  if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                    errors.push("- " + validationErrorDictionary[fieldName]);
                  }
                }
              } else {
                errors.push(error.response.data);
              }
              this.$store.dispatch("SHOW_ERROR_ALERT", errors);
            });
        }
      });
    }
  }
};
</script>

<style></style>
